import {ShopItem} from '../../../model/shop-item.ts';
import {Amount} from "@/app/shop/model/accounting/amount.ts";

export class OrderItem {
  public uuid!: string;
  public uuidOrder?: string;
  public uuidShopItem?: string;
  public name?: string;
  public quantity!: number;
  public price?: Amount;
  public priceTotal?: Amount;
  public dateCreated!: Date;
  public dateUpdated!: Date;

  public shopItem!: ShopItem;
}
